import React from "react";
import { NavLink } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { STORAGE_URL } from "constants";
import { useFetch, useLanguage, usePagination } from "hooks";
import { Layout, Pagination, Icons, Skeletons } from "components";
import Nav from "../Nav";

const MySwal = withReactContent(Swal);

export default function Favourite() {
  const language = useLanguage(); // language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { page } = usePagination();
  const [favouriteBooksResponse, favouriteBooksRequest] = useFetch(
    `User/getUserFavorites`
  ); // to call information resource that user liked
  const [_, bookUnFavouriteRequest] = useFetch(
    `User/addRemoveFavorites`,
    "POST"
  ); // remove a information resource from the favorites list if user click on the Trash icon

  const handleUnfavouriteBook = (bookId) => {
    MySwal.fire({
      icon: "warning",
      title: language.are_you_sure,
      showCancelButton: true,
      confirmButtonText: language.confirm,
      cancelButtonText: language.cancel,
    }).then((result) => {
      if (result.isConfirmed) {
        bookUnFavouriteRequest({
          book_id: bookId,
        }).then((res) => {
          favouriteBooksRequest(null, `?page=${page}`);
        });
      }
    });
  }; // remove a information resource from the favorites list if user click on the Trash icon and then fire a swal

  const BookRowItem = ({ id, image, name, subtitle }) => (
    <div className="bg-white rounded mb-2 py-4">
      <Row className="align-items-center px-5">
        <Col xl={4} lg={5} md={9} sm={9} xs={9}>
          <Row className="align-items-center">
            <Col xl={3} lg={3} md={4} sm={3} xs={3}>
              <NavLink to={`/book/${id}`}>
                <img
                  src={`${STORAGE_URL}${image}`}
                  alt="Book"
                  className="w-100"
                />
              </NavLink>
            </Col>
            <Col xl={9} lg={9} md={8} sm={9} xs={9}>
              <NavLink to={`/book/${id}`}>
                <h6 className="fw-bold text-black cut-text-1">{name}</h6>
              </NavLink>
            </Col>
          </Row>
        </Col>
        <Col xl={7} lg={5} md={0} sm={0} xs={0} className="d-none d-lg-block">
          <small className="fw-normal text-light5 cut-text-1">{subtitle}</small>
        </Col>
        <Col xl={1} lg={2} md={3} sm={3} xs={3}>
          <Row className="align-items-center">
            <Col
              xl={6}
              lg={6}
              md={6}
              sm={6}
              xs={6}
              className="p-0 m-0 text-center"
            >
              <Icons.Trash
                onClick={() => handleUnfavouriteBook(id)}
                role="button"
                className="control_svg"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  ); /* show a single item ( information resource ) */

  React.useEffect(() => {
    favouriteBooksRequest(null, `?page=${page}`);
  }, [favouriteBooksRequest, page]);

  return (
    <Layout>
      <section id="profile" className="mb-3">
        <Container>
          <Row>
            <Col xs={12}>
              <h1 className="text-primary fw-bold cut-text-1">
                {language.favourite}
              </h1>
            </Col>
          </Row>

          <Row className="mt-4 mt-4 mt-4 ">
            {/* Right */}
            <Col xl={3} lg={3} md={4} sm={12} xs={12}>
              <Nav />
            </Col>
            <Col
              xl={9}
              lg={9}
              md={8}
              sm={12}
              xs={12}
              className="mt-4 mt-4 mt-4  mt-md-0"
            >
              {/* Left */}
              {favouriteBooksResponse.loading ? (
                <Skeletons.HorizontalCardSkeleton />
              ) : favouriteBooksResponse.result?.data?.length > 0 ? (
                <>
                  <Col xs={12}>
                    <Row>
                      {favouriteBooksResponse.result.data.map((item) => (
                        <Col
                          key={item.id}
                          xl={12}
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                        >
                          <BookRowItem
                            id={item.id}
                            name={item.name}
                            subtitle={item.sub_title}
                            image={item.cover_image}
                            date={item.date}
                          />
                        </Col>
                      ))}{" "}
                      {/* show a single item ( information resource ) */}
                    </Row>
                  </Col>
                  <Col xs={12}>
                    {favouriteBooksResponse.result.meta && (
                      <Pagination
                        count={favouriteBooksResponse.result.meta.total}
                        perPage={favouriteBooksResponse.result.meta.per_page}
                      /> // pagination
                    )}
                  </Col>
                </>
              ) : (
                <Row className="justify-content-center">
                  <Col md={6} xs={12}>
                    <img
                      className="not-found w-100"
                      src={"/images/Reading glasses-pana.svg"}
                      alt="Not Found"
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
}
